import { Flex as AntFlex } from 'antd'
import type { FlexProps } from 'antd'

// Wrapper layout Flex: bọc AntD Flex để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiFlex(props: FlexProps) {
  return <AntFlex {...props} />
}
